export const noPreview = "fod";
export default {noPreview};